import { useEffect, useRef } from "react";

export default function usePrevious<T>(value: T): T | undefined {
	const ref = useRef<T>(undefined);

	useEffect(() => {
		ref.current = value;
	}, [value]);

	return ref.current;
}

export function usePrevious2<T>(value: T): T {
	const ref = useRef<T>(value);

	useEffect(() => {
		ref.current = value;
	}, [value]);

	return ref.current;
}